import React from "react";
import MetaTags from "react-meta-tags";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NasHeader from "../../layouts/_nas/NasHeader";
import NasFooter from "../../layouts/_nas/NasFooter";
import Breadcrumbs from "../../layouts/Breadcrumbs";

const BRAND = "#032C65";
const ACCENT = "#E63946";

const NasPaymentCancelPage = () => {
  const { t } = useTranslation();
  const { token } = useParams();

  return (
    <>
      <MetaTags>
        <title>Holy Spirit Church | {t("_payment_cancel_title")}</title>
      </MetaTags>
      <NasHeader />
      <Breadcrumbs breadcrumb={{ pagename: t("_payment_cancel_title") }} />
      <section className="section" style={{ background: "#f7f8fa", paddingBottom: 80 }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6 text-center">
              <div
                style={{
                  background: "#fff",
                  borderRadius: 18,
                  boxShadow: "0 10px 40px rgba(3,44,101,0.08)",
                  padding: "2.75rem 2rem",
                }}
              >
                <div
                  style={{
                    width: 72,
                    height: 72,
                    borderRadius: "50%",
                    background: "#fdecea",
                    color: ACCENT,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 18,
                    fontSize: 32,
                  }}
                >
                  <i className="fal fa-times" />
                </div>
                <h3 style={{ color: BRAND, fontWeight: 800 }}>{t("_payment_cancel_title")}</h3>
                <p style={{ color: "#666", lineHeight: 1.7 }}>{t("_payment_cancel_body")}</p>
                <div style={{ marginTop: 28, display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
                  {token && (
                    <Link
                      to={`/pay/${token}`}
                      className="btn"
                      style={{ background: ACCENT, color: "#fff" }}
                    >
                      {t("_payment_try_again")}
                    </Link>
                  )}
                  <Link to="/" className="btn" style={{ background: BRAND, color: "#fff" }}>
                    {t("_home")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <NasFooter />
    </>
  );
};

export default NasPaymentCancelPage;
